import isEmpty from 'lodash/isEmpty';
import { diff } from './diff';

export const checkObjectsAreDifferent = (gObject: Record<string, any>, gBase: Record<string, any>): boolean => {
  return !isEmpty(diff(gObject, gBase));
};
